import { SqliteJsonRepository } from './SqliteJsonRepository';
import { TenantContext } from '@infra/tenancy/TenantContext';
import type { User } from '@shared/types/User';
import type { IUserRepository } from '@infra/auth/AuthService';
import { uuid } from '@shared/utils/uuid';

export class SqliteUserRepository extends SqliteJsonRepository<User> implements IUserRepository {
  constructor() {
    super('users');
  }

  async findByEmail(email: string, tenantId?: string): Promise<User | undefined> {
    const normalized = email.toLowerCase().trim();
    const scoped = tenantId ?? TenantContext.getInstance().tryGetTenant()?.id;
    const matches = scoped
      ? await this.findBy({ email: normalized, tenant_id: scoped } as Partial<User>)
      : (await this.findAll()).filter((user) => user.email === normalized);
    if (scoped) {
      return matches.find((user) => user.email === normalized && user.tenant_id === scoped);
    }
    if (matches.length !== 1) return undefined;
    return matches[0];
  }

  async create(user: Omit<User, 'id'>): Promise<User> {
    const created: User = { ...user, id: uuid('user') };
    await this.save(created);
    return created;
  }
}
